(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenKortblok) return;
    // Læg i kurv fra kortet ligger nu i snippets/supermen-kort, så det også virker på forsiden
    window.SupermenKortblok = 'ny';

    // Packshots på hvid bund lægges ind på den grå flade (samme billedscript som produktsiden)
    function klar(root) {
      var S = window.SupermenVare;
      if (!S || !S.sampleBg) return;
      Array.prototype.forEach.call((root || document).querySelectorAll('.spd-kortblok [data-bg]'), S.sampleBg);
    }
    window.SupermenKortKlar = klar;

    function init() { klar(document); }
    // Venter et øjeblik, så billedscriptet i Supermen vare er klar, uanset rækkefølgen i temaets samlede fil
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.setTimeout(init, 0); });
    else window.setTimeout(init, 0);
    document.addEventListener('shopify:section:load', function (e) { klar(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_supermen-ommen-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('supermen-film')) {
    const I = {
      spil: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4.5v15l12.5-7.5z"/></svg>',
      pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>',
      lyd: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5z" fill="currentColor"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/></svg>',
      lav: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5z" fill="currentColor"/><path d="M15.5 9a4 4 0 0 1 0 6"/></svg>',
      stum: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5"/></svg>',
      stor: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"/></svg>',
      lille: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 4v5H4M15 4v5h5M20 15h-5v5M4 15h5v5"/></svg>'
    };
    const mmss = (x) => {
      x = Math.max(0, Math.floor(x || 0));
      return Math.floor(x / 60) + ':' + String(x % 60).padStart(2, '0');
    };
    /* iPhone styrer kun lydstyrken med knapperne på telefonen */
    const kanStyrke = (() => {
      const t = document.createElement('video');
      t.volume = 0.5;
      return t.volume === 0.5;
    })();
    const fuldEl = () => document.fullscreenElement || document.webkitFullscreenElement;

    class SupermenFilm extends HTMLElement {
      connectedCallback() {
        if (this._klar) return;
        this._klar = true;
        const s = this;
        const $ = (k) => s.querySelector('[data-' + k + ']');
        const v = s.querySelector('video');
        const se = $('se'), bgPause = $('pause'), midt = $('midt'), luk = $('luk'), spor = $('spor'), spil = $('spil');
        const tNu = $('nu'), tAlt = $('alt'), lyd = $('lyd'), styrke = $('styrke'), stor = $('stor');
        let film = false, varStille = false, skjul = 0, traek = false, sidste = 1, styrkeStart = null, klikTimer = 0;
        if (!kanStyrke) s.classList.add('ingen-styrke');

        const erStor = () => fuldEl() === s || s.classList.contains('stor');
        const opd = () => {
          const pa = v.paused;
          bgPause.innerHTML = pa ? I.spil : I.pause;
          bgPause.setAttribute('aria-label', pa ? 'Afspil baggrundsvideoen' : 'Sæt baggrundsvideoen på pause');
          s.classList.toggle('pauset', pa);
          spil.innerHTML = pa ? I.spil : I.pause;
          spil.setAttribute('aria-label', pa ? 'Afspil' : 'Pause');
          const stumt = v.muted || v.volume === 0;
          const vol = stumt ? 0 : Math.round(v.volume * 100);
          lyd.innerHTML = stumt ? I.stum : vol < 50 ? I.lav : I.lyd;
          lyd.setAttribute('aria-label', stumt ? 'Slå lyden til' : 'Slå lyden fra');
          styrke.value = vol;
          styrke.style.setProperty('--p', vol + '%');
          styrke.setAttribute('aria-valuetext', vol + ' %');
          const st = erStor();
          stor.innerHTML = st ? I.lille : I.stor;
          stor.setAttribute('aria-label', st ? 'Gør mindre igen' : 'Stor skærm');
        };
        const tid = () => {
          if (traek) return;
          const d = v.duration || 0, f = d ? v.currentTime / d : 0;
          spor.value = Math.round(f * 1000);
          spor.style.setProperty('--p', f * 100 + '%');
          tNu.textContent = mmss(v.currentTime);
          tAlt.textContent = mmss(d);
          spor.setAttribute('aria-valuetext', mmss(v.currentTime) + ' af ' + mmss(d));
        };
        const vaek = () => {
          clearTimeout(skjul);
          s.classList.remove('stille');
          if (film && !v.paused) skjul = setTimeout(() => { if (!traek) s.classList.add('stille'); }, 2500);
        };
        const skift = () => { v.paused ? v.play().catch(() => {}) : v.pause(); };

        /* Hele vinduet, når browseren ikke må gå i fuld skærm. Som popover ligger filmen øverst,
           uanset hvad temaet ellers har af lag og animationer omkring sektionen. */
        const pseudo = (til) => {
          if (til) {
            if (typeof s.showPopover === 'function') {
              s.setAttribute('popover', 'manual');
              try { s.showPopover(); } catch (_) {}
            }
            s.classList.add('stor');
          } else {
            s.classList.remove('stor');
            if (s.hasAttribute('popover')) {
              try { s.hidePopover(); } catch (_) {}
              s.removeAttribute('popover');
            }
          }
          document.documentElement.classList.toggle('som-laast', til);
          opd();
        };
        const gaaLille = () => {
          if (fuldEl()) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); return; }
          pseudo(false);
        };
        const skiftStor = () => {
          if (erStor()) { gaaLille(); return; }
          const r = s.requestFullscreen || s.webkitRequestFullscreen;
          if (!r) { pseudo(true); return; }
          try {
            const x = r.call(s);
            if (x && x.then) x.then(opd, () => pseudo(true));
            else setTimeout(() => { if (!fuldEl()) pseudo(true); }, 300);
          } catch (_) { pseudo(true); }
        };

        const aabn = () => {
          film = true;
          s.dataset.t = 'film';
          if (filmKilde && v.getAttribute('src') && v.getAttribute('src') !== filmKilde) byt(filmKilde);
          v.loop = false;
          v.currentTime = 0;
          v.muted = false;
          v.volume = sidste;
          v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
          opd();
          tid();
          spil.focus({ preventScroll: true });
          vaek();
        };
        const tilBaggrund = () => {
          if (erStor()) gaaLille();
          film = false;
          s.dataset.t = 'baggrund';
          s.classList.remove('stille');
          clearTimeout(skjul);
          v.muted = true;
          v.loop = true;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) v.play().catch(() => {});
          opd();
          se.focus({ preventScroll: true });
        };
        const lydTil = () => {
          v.muted = false;
          if (v.volume < 0.05) v.volume = sidste >= 0.1 ? sidste : 0.5;
          opd();
        };

        se.addEventListener('click', aabn);
        bgPause.addEventListener('click', () => { skift(); opd(); });
        v.addEventListener('click', (e) => {
          if (!film) { aabn(); return; }
          if (varStille) { varStille = false; vaek(); return; }
          /* Vent kort med musen, så et dobbeltklik (stor skærm) ikke også sætter på pause */
          if (e.pointerType === 'mouse') { clearTimeout(klikTimer); klikTimer = setTimeout(skift, 220); }
          else skift();
        });
        v.addEventListener('dblclick', () => { clearTimeout(klikTimer); if (film) skiftStor(); });
        midt.addEventListener('click', () => v.play().catch(() => {}));
        spil.addEventListener('click', () => { skift(); opd(); });
        luk.addEventListener('click', tilBaggrund);
        stor.addEventListener('click', skiftStor);
        lyd.addEventListener('click', () => {
          if (v.muted || v.volume === 0) lydTil();
          else { v.muted = true; opd(); }
        });
        styrke.addEventListener('input', () => {
          if (styrkeStart === null) styrkeStart = v.muted ? 0 : v.volume;
          const x = styrke.value / 100;
          styrke.style.setProperty('--p', styrke.value + '%');
          v.volume = x;
          v.muted = x === 0;
          opd();
          vaek();
        });
        styrke.addEventListener('change', () => {
          const x = styrke.value / 100;
          if (x > 0) sidste = x;
          else if (styrkeStart > 0) sidste = styrkeStart;
          styrkeStart = null;
        });
        spor.addEventListener('input', () => {
          traek = true;
          const d = v.duration || 0, f = spor.value / 1000;
          spor.style.setProperty('--p', f * 100 + '%');
          tNu.textContent = mmss(f * d);
          if (d) v.currentTime = f * d;
          vaek();
        });
        spor.addEventListener('change', () => { traek = false; tid(); });
        ['pointerup', 'touchend'].forEach((t) => spor.addEventListener(t, () => { traek = false; }));
        ['play', 'pause', 'volumechange'].forEach((t) => v.addEventListener(t, () => { opd(); if (film) vaek(); }));
        ['timeupdate', 'loadedmetadata', 'durationchange', 'seeked'].forEach((t) => v.addEventListener(t, tid));
        v.addEventListener('ended', () => { if (film) tilBaggrund(); });
        /* Baggrundsfilmen hentes først, når resten af siden er hentet, så siden ikke venter på den */
        const start = () => {
          if (!film && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) v.play().catch(() => {});
        };
        /* Shopify giver kun den største udgave af filmen (1080p) til temaet. På mobil slår vi de mindre
           udgaver op i filmens afspilningsliste: 480p i baggrunden og 720p, når man trykker "Se filmen".
           Går noget galt, bruges den store */
        let forSent = false, filmKilde = '';
        const byt = (url) => {
          const fejl = () => { v.removeAttribute('src'); v.load(); if (film) v.play().catch(() => {}); else start(); };
          v.addEventListener('error', fejl, { once: true });
          v.addEventListener('loadeddata', () => v.removeEventListener('error', fejl), { once: true });
          v.src = url;
        };
        const mindre = () => {
          const storKilde = (v.querySelector('source:not([media])') || {}).src || '';
          const m = storKilde.match(/^(.*\/)([0-9a-f]+)\.[^/?]+\.mp4(\?[^#]*)?$/i);
          if (!m || v.querySelector('source[media]') || !window.fetch || !window.matchMedia('(max-width: 749px)').matches) return Promise.resolve();
          return fetch(m[1] + m[2] + '.m3u8' + (m[3] || ''))
            .then((r) => (r.ok ? r.text() : ''))
            .then((txt) => {
              const linjer = txt.split(/\r?\n/), bedst = { 480: ['', 0], 720: ['', 0] };
              linjer.forEach((l, i) => {
                const h = +((l.match(/RESOLUTION=\d+x(\d+)/) || [])[1] || 0);
                const n = (linjer[i + 1] || '').trim().match(/^(.+\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/);
                if (!h || !n) return;
                [480, 720].forEach((max) => {
                  if (h <= max && h > bedst[max][1]) bedst[max] = [m[1] + n[1] + '-' + n[2] + '-' + n[3] + '.mp4' + (m[3] || ''), h];
                });
              });
              filmKilde = bedst[720][0];
              const baggrund = bedst[480][0] || filmKilde;
              if (baggrund && !forSent && !film) byt(baggrund);
            })
            .catch(() => {});
        };
        const klar = () => {
          Promise.race([mindre(), new Promise((r) => setTimeout(r, 3000))]).then(() => { forSent = true; start(); });
        };
        if (document.readyState === 'complete') klar();
        else window.addEventListener('load', klar, { once: true });
        this._fs = () => opd();
        document.addEventListener('fullscreenchange', this._fs);
        document.addEventListener('webkitfullscreenchange', this._fs);
        s.addEventListener('pointerdown', () => { varStille = film && s.classList.contains('stille'); if (film) vaek(); }, true);
        ['pointermove', 'focusin'].forEach((t) => s.addEventListener(t, () => { if (film) vaek(); }));
        s.addEventListener('keydown', (e) => {
          if (!film) return;
          const k = e.key, iSkyder = e.target.type === 'range';
          if (k === 'Escape' && s.classList.contains('stor')) { e.preventDefault(); pseudo(false); stor.focus(); }
          else if ((k === ' ' && e.target.tagName !== 'BUTTON') || k === 'k') { e.preventDefault(); skift(); }
          else if (k === 'm') lyd.click();
          else if (k === 'f') skiftStor();
          else if (!iSkyder && k === 'ArrowRight') { e.preventDefault(); v.currentTime = Math.min(v.duration || 0, v.currentTime + 5); }
          else if (!iSkyder && k === 'ArrowLeft') { e.preventDefault(); v.currentTime = Math.max(0, v.currentTime - 5); }
          else if (!iSkyder && (k === 'ArrowUp' || k === 'ArrowDown')) {
            e.preventDefault();
            const x = Math.round(Math.min(1, Math.max(0, (v.muted ? 0 : v.volume) + (k === 'ArrowUp' ? 0.1 : -0.1))) * 100) / 100;
            v.volume = x;
            v.muted = x === 0;
            if (x > 0) sidste = x;
            opd();
          }
          vaek();
        });
        opd();
      }
      disconnectedCallback() {
        if (this._fs) {
          document.removeEventListener('fullscreenchange', this._fs);
          document.removeEventListener('webkitfullscreenchange', this._fs);
        }
        document.documentElement.classList.remove('som-laast');
      }
    }
    customElements.define('supermen-film', SupermenFilm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenFiltre) return;
    window.SupermenFiltre = true;
    var mobil = window.matchMedia('(max-width: 989px)');
    var styring = null;

    function alle(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function vaert(root) { return root.closest('.shopify-section') || document.body; }
    function sig(root, tekst) {
      var s = root.querySelector('[data-spf-status]');
      if (!s) return;
      s.textContent = '';
      window.setTimeout(function () { s.textContent = tekst; }, 80);
    }

    // Adressen ud fra formularen: tomme felter (f.eks. pris) tages ikke med
    function adresse(root) {
      var form = root.querySelector('[data-spf-form]');
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      var s = p.toString();
      return form.getAttribute('action') + (s ? '?' + s : '');
    }

    // Adressen uden side og #, så "tilbage" fra et #-link ikke henter varerne igen
    function adrNoegle(href) {
      var u = new URL(href, window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      return u.pathname + '?' + u.searchParams.toString();
    }
    var vistAdr = adrNoegle(window.location.href);

    /* ---------- Hent nye varer og opdatér siden ---------- */
    function hent(root, href, skub) {
      var host = vaert(root);
      var u = new URL(href, window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      // Sektioner uden vores varegitter (f.eks. Horizons søgeside) genindlæses som en almindelig side
      if (!host.querySelector('[data-spf-del="resultater"]')) { window.location.assign(u.toString()); return; }
      var hentU = new URL(u.toString());
      hentU.searchParams.set('section_id', root.dataset.section);
      if (styring) styring.abort();
      styring = 'AbortController' in window ? new AbortController() : null;
      host.classList.add('spf-henter');
      return fetch(hentU.toString(), { signal: styring ? styring.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          opdater(root, host, doc);
          var ny = u.pathname + u.search;
          if (skub) window.history.pushState({ spf: root.dataset.section }, '', ny);
          vistAdr = adrNoegle(ny);
          host.classList.remove('spf-henter');
          var antal = root.querySelector('[data-spf-del="antal"]');
          sig(root, (antal ? antal.textContent.trim() : '') + ' vises.');
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          window.location.assign(u.toString());
        });
    }

    function opdater(root, host, doc) {
      var aktiv = document.activeElement, fokusId = aktiv && host.contains(aktiv) ? aktiv.id : '';
      // 1. Felter og knapper på stedet, så åbne menuer, rulning og fokus bliver, hvor de er
      alle(host, '[data-spf-liste]').forEach(function (liste) {
        var ny = doc.querySelector('[data-spf-liste="' + liste.dataset.spfListe + '"]');
        if (!ny) return;
        var gamle = alle(liste, '[data-spf-input]').map(function (i) { return i.id; }).join('|');
        var nye = alle(ny, '[data-spf-input]').map(function (i) { return i.id; }).join('|');
        if (gamle !== nye) {
          var udvidet = liste.dataset.udvidet;
          liste.innerHTML = ny.innerHTML;
          if (udvidet) alle(liste, '[data-spf-ekstra]').forEach(function (li) { li.hidden = false; });
          return;
        }
        alle(liste, '[data-spf-input]').forEach(function (inp) {
          var n = ny.querySelector('#' + CSS.escape(inp.id));
          if (!n) return;
          inp.checked = n.checked;
          inp.disabled = n.disabled;
          var a = inp.parentNode.querySelector('[data-spf-antal]'), na = n.parentNode.querySelector('[data-spf-antal]');
          if (a && na) a.textContent = na.textContent;
        });
      });
      alle(host, '[data-spf-pris]').forEach(function (inp) {
        var n = doc.getElementById(inp.id);
        if (!n) return;
        if (inp !== document.activeElement) inp.value = n.value;
        inp.placeholder = n.placeholder;
      });
      var nsort = doc.querySelector('[data-spf-sort]:checked');
      if (nsort) alle(root, '[data-spf-sort]').forEach(function (r) { r.checked = r.value === nsort.value; });
      // 2. Tekster, valgte filtre og varerne skiftes ud
      alle(host, '[data-spf-del]').forEach(function (el) {
        var n = doc.querySelector('[data-spf-del="' + el.dataset.spfDel + '"]');
        if (n) el.replaceWith(document.importNode(n, true));
      });
      if (fokusId && !document.getElementById(fokusId)) fokusId = '';
      if (fokusId && document.activeElement !== document.getElementById(fokusId)) document.getElementById(fokusId).focus({ preventScroll: true });
      if (window.SupermenKortKlar) window.SupermenKortKlar(host);
      taethed(root);
      host.dispatchEvent(new CustomEvent('supermen:filtre', { bubbles: true }));
    }

    /* ---------- Panel på mobil ---------- */
    function aabn(root, knap) {
      var panel = root.querySelector('[data-spf-panel]'), slor = root.querySelector('.spf-slor');
      if (!panel) return;
      root._knap = knap;
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.classList.add('is-aaben');
      if (slor) slor.hidden = false;
      knap.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('spf-laast');
      // Grupper med valg er åbne; ellers den første
      var g = alle(panel, '[data-spf-gruppe]');
      var valgt = g.filter(function (d) { return d.querySelector('input:checked') || alle(d, '[data-spf-pris]').some(function (i) { return i.value; }); });
      (valgt.length ? valgt : g.slice(0, 1)).forEach(function (d) { d.open = true; });
      window.setTimeout(function () { var l = panel.querySelector('.spf-panel__luk'); if (l) l.focus(); }, 60);
    }
    function luk(root) {
      var panel = root.querySelector('[data-spf-panel]'), slor = root.querySelector('.spf-slor');
      if (!panel || !panel.classList.contains('is-aaben')) return;
      panel.classList.remove('is-aaben');
      panel.setAttribute('role', 'region');
      panel.removeAttribute('aria-modal');
      if (slor) slor.hidden = true;
      document.documentElement.classList.remove('spf-laast');
      var k = root._knap || root.querySelector('[data-spf-aabn]');
      if (k) { k.setAttribute('aria-expanded', 'false'); k.focus(); }
    }
    function faelde(root, e) {
      var panel = root.querySelector('[data-spf-panel].is-aaben');
      if (!panel) return;
      var f = alle(panel, 'a[href], button:not([disabled]), input:not([disabled]), select, summary, [tabindex]:not([tabindex="-1"])').filter(function (x) { return x.offsetParent !== null || x.tagName === 'SUMMARY'; });
      if (!f.length) return;
      var forste = f[0], sidste = f[f.length - 1];
      if (e.shiftKey && document.activeElement === forste) { e.preventDefault(); sidste.focus(); }
      else if (!e.shiftKey && document.activeElement === sidste) { e.preventDefault(); forste.focus(); }
    }

    /* ---------- Små menuer på computer: én ad gangen ---------- */
    function lukMenuer(root, undtagen) {
      if (mobil.matches || !root.querySelector('.spf--bar, .spf-gruppe')) return;
      if (!root.classList.contains('spf--bar')) return;
      alle(root, '[data-spf-gruppe][open]').forEach(function (d) { if (d !== undtagen) d.open = false; });
    }

    /* ---------- Billedstørrelse ---------- */
    var lilleSkaerm = window.matchMedia('(max-width: 749px)');
    function noegle() { return 'spl-taethed-' + (lilleSkaerm.matches ? 'm' : 'd'); }
    // Uden eget valg: på mobil det, der er sat i temaet (2 pr. række = små billeder), ellers store billeder
    function hentValg(gitter) {
      var v = null;
      try { v = window.localStorage.getItem(noegle()); } catch (e) {}
      if (v === 'stor' || v === 'lille') return v;
      return lilleSkaerm.matches ? (gitter.dataset.splStdM || 'lille') : 'stor';
    }
    function taethed(root, valg) {
      var gruppe = root.querySelector('[data-spf-taethed-gruppe]');
      if (!gruppe) return;
      var gitre = alle(vaert(root), '[data-spl-gitter]');
      gruppe.hidden = !gitre.length;
      if (!gitre.length) return;
      if (valg) { try { window.localStorage.setItem(noegle(), valg); } catch (e) {} }
      valg = valg || hentValg(gitre[0]);
      gitre.forEach(function (g) { g.dataset.taethed = valg; });
      alle(gruppe, '[data-spf-taethed]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.spfTaethed === valg ? 'true' : 'false'); });
    }

    /* ---------- Hændelser ---------- */
    var prisT;
    document.addEventListener('change', function (e) {
      var t = e.target;
      var root = t.form && t.form.closest('[data-spf]');
      if (!root && t.closest) root = t.closest('[data-spf]');
      if (!root) return;
      // Andre stavemåder af samme størrelse følger med det synlige felt
      if (t.dataset && t.dataset.spfTvillinger) t.dataset.spfTvillinger.split(' ').forEach(function (id) { var x = document.getElementById(id); if (x) x.checked = t.checked; });
      if (t.matches('[data-spf-sort]')) { var sm = t.closest('[data-spf-sortmenu]'); if (sm) { sm.open = false; sm.querySelector('summary').focus({ preventScroll: true }); } }
      if (t.matches('[data-spf-input], [data-spf-sort]')) hent(root, adresse(root), true);
      else if (t.matches('[data-spf-pris]')) { window.clearTimeout(prisT); hent(root, adresse(root), true); }
    });
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-spf-pris]')) return;
      var root = t.closest('[data-spf]');
      window.clearTimeout(prisT);
      prisT = window.setTimeout(function () { hent(root, adresse(root), true); }, 800);
    });
    document.addEventListener('submit', function (e) {
      var root = e.target.closest && e.target.closest('[data-spf]');
      if (!root || !e.target.matches('[data-spf-form]')) return;
      e.preventDefault();
      window.clearTimeout(prisT);
      hent(root, adresse(root), true);
    });
    document.addEventListener('keydown', function (e) {
      if (!e.target.matches || !e.target.matches('[data-spf-pris]') || e.key !== 'Enter') return;
      e.preventDefault();
      var root = e.target.closest('[data-spf]');
      window.clearTimeout(prisT);
      hent(root, adresse(root), true);
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      // Klik uden for en åben menu lukker den
      alle(document, '[data-spf].spf--bar').forEach(function (r) {
        if (!r.contains(t) || !t.closest('[data-spf-gruppe]')) lukMenuer(r);
      });
      alle(document, '[data-spf-sortmenu][open]').forEach(function (d) { if (!d.contains(t)) d.open = false; });
      var root = t.closest && t.closest('[data-spf]');
      if (!root) {
        var ud = t.closest && t.closest('a[data-spf-link]');
        var udRoot = ud && vaert(ud).querySelector('[data-spf]');
        if (udRoot) { e.preventDefault(); hent(udRoot, ud.href, true); }
        return;
      }
      var a = t.closest('a[data-spf-link]');
      if (a) { e.preventDefault(); hent(root, a.href, true); return; }
      var ab = t.closest('[data-spf-aabn]');
      if (ab) { aabn(root, ab); return; }
      if (t.closest('[data-spf-luk]')) { luk(root); return; }
      var fl = t.closest('[data-spf-flere]');
      if (fl) {
        var liste = fl.parentNode.querySelector('[data-spf-liste]');
        alle(liste, '[data-spf-ekstra]').forEach(function (li) { li.hidden = false; });
        liste.dataset.udvidet = '1';
        fl.remove();
        return;
      }
      var tb = t.closest('[data-spf-taethed]');
      if (tb) taethed(root, tb.dataset.spfTaethed);
    });
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('[data-spf-gruppe]') || !d.open) return;
      var root = d.closest('[data-spf]');
      if (root) lukMenuer(root, d);
    }, true);
    document.addEventListener('keydown', function (e) {
      alle(document, '[data-spf]').forEach(function (root) {
        if (e.key === 'Escape') {
          var sm = root.querySelector('[data-spf-sortmenu][open]');
          if (sm) { sm.open = false; sm.querySelector('summary').focus(); return; }
          var aaben = root.querySelector('[data-spf-panel].is-aaben');
          if (aaben) { luk(root); return; }
          var menu = root.classList.contains('spf--bar') && !mobil.matches && root.querySelector('[data-spf-gruppe][open]');
          if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
        }
        if (e.key === 'Tab') faelde(root, e);
      });
    });
    // Kun når filtre eller sortering i adressen er skiftet; ikke ved "tilbage" fra et #-link (f.eks. "Gå direkte til varerne")
    window.addEventListener('popstate', function () {
      var ny = adrNoegle(window.location.href);
      if (ny === vistAdr) return;
      vistAdr = ny;
      alle(document, '[data-spf]').forEach(function (root) { hent(root, window.location.href, false); });
    });
    mobil.addEventListener && mobil.addEventListener('change', function () {
      alle(document, '[data-spf]').forEach(function (root) { luk(root); if (!mobil.matches) lukMenuer(root); });
    });
    lilleSkaerm.addEventListener && lilleSkaerm.addEventListener('change', function () {
      alle(document, '[data-spf]').forEach(function (root) { taethed(root); });
    });

    function init() { alle(document, '[data-spf]').forEach(function (r) { taethed(r); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["supermen-gavekort-valg"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('supermen-gavekort-valg')) return;
    class SupermenGavekortValg extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-gkv-skift]');
        if (!link) return;
        let data = { her: {}, der: {} };
        try { data = JSON.parse(this.querySelector('[data-gkv-data]').textContent); } catch (e) {}
        const grund = link.getAttribute('href');
        const omraade = this.closest('.shopify-section') || document;
        /* Det valgte beløb: den valgte variant, ellers værdien i beløbsmenuen */
        const beloeb = () => {
          const input = omraade.querySelector('[data-spd-variant-input]');
          const id = (input && input.value) || new URL(location.href).searchParams.get('variant');
          if (id && data.her[id]) return data.her[id];
          const menu = omraade.querySelector('.spd-str__select[data-spd-opt="0"]');
          return menu ? menu.value : '';
        };
        const opdater = () => {
          const id = data.der[beloeb()];
          link.setAttribute('href', id ? grund + (grund.includes('?') ? '&' : '?') + 'variant=' + id : grund);
        };
        this.opdater = opdater;
        omraade.addEventListener('change', opdater);
        link.addEventListener('pointerdown', opdater);
        link.addEventListener('focus', opdater);
        link.addEventListener('click', opdater);
        opdater();
      }
      disconnectedCallback() {
        const omraade = this.closest('.shopify-section') || document;
        if (this.opdater) omraade.removeEventListener('change', this.opdater);
      }
    }
    customElements.define('supermen-gavekort-valg', SupermenGavekortValg);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["supermen-giv-besked"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('supermen-giv-besked')) return;
    /* Uden størrelse (one size) falder " i [størrelse]" væk */
    const fyld = (tekst, ord) => String(tekst || '').replace(ord['størrelse'] === 'varen' || ord['størrelse'] === 'den' ? /\s+i \[størrelse\]/g : /$^/, '').replace(/\[(størrelse|navn|email|vare)\]/g, (m, k) => (ord[k] != null ? ord[k] : m));
    const emailOk = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);

    class SupermenGivBesked extends HTMLElement {
      connectedCallback() {
        if (this.klar) return;
        this.klar = true;
        const d = this.dataset;
        this.omr = this.closest('.shopify-section') || document;
        this.input = this.omr.querySelector('[data-spd-variant-input]');
        this.kob = this.omr.querySelector('.spd-kob');
        this.knap = this.querySelector('[data-gb-aaben]');
        this.panel = this.querySelector('[data-gb-panel]');
        this.form = this.querySelector('[data-gb-form]');
        this.vaelg = this.querySelector('[data-gb-vaelg]');
        try { this.data = JSON.parse(this.querySelector('[data-gb-data]').textContent); } catch (e) { this.data = {}; }
        this.alleUde = Object.keys(this.data).every((id) => !this.data[id].a);
        this.enStr = d.enStr === 'true';

        this.opdater = () => this.vis();
        this.omr.addEventListener('change', this.opdater);
        this.knap.addEventListener('click', () => this.aaben());
        this.querySelector('[data-gb-luk]').addEventListener('click', () => this.luk());
        this.panel.addEventListener('cancel', (e) => { e.preventDefault(); this.luk(); });
        this.panel.addEventListener('click', (e) => { if (e.target === this.panel) this.luk(); });
        if (this.vaelg) this.vaelg.addEventListener('change', () => this.tekster());
        /* Første gang tjekkes felterne. Bagefter sendes Shopifys kundeformular på normal vis */
        this.form.addEventListener('submit', (e) => {
          if (this.videre) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.send();
        });
        this.vis();

        /* Tilbage fra Shopify efter tilmeldingen: vis tak. Temaet kan selv rydde adressen, så det er den gemte tilmelding på denne side, der tæller */
        let gem = null;
        try { gem = JSON.parse(sessionStorage.getItem('spd-gb') || 'null'); } catch (e) {}
        if (gem && Date.now() - gem.tid > 10 * 60 * 1000) { try { sessionStorage.removeItem('spd-gb'); } catch (e) {} gem = null; }
        if (gem && gem.sti === location.pathname) {
          try { sessionStorage.removeItem('spd-gb'); } catch (e) {}
          const u = new URL(location.href);
          u.searchParams.delete('giv_besked');
          u.searchParams.delete('customer_posted');
          const hash = /^#spd-gb-form/.test(u.hash) ? '' : u.hash;
          history.replaceState(history.state, '', u.pathname + u.search + hash);
          this.aaben(true, gem);
        }
      }
      disconnectedCallback() {
        if (this.omr) this.omr.removeEventListener('change', this.opdater);
      }
      valgt() {
        const id = this.input && this.input.value;
        if (id && this.data[id]) return { id: id, t: this.data[id].t, a: this.data[id].a };
        if (this.enStr) { const id1 = Object.keys(this.data)[0]; return { id: id1, t: '', a: this.data[id1].a }; }
        return null;
      }
      vis() {
        const v = this.valgt();
        const aktiv = (v && !v.a) || (!v && this.alleUde);
        this.knap.hidden = !aktiv;
        this.classList.toggle('er-aktiv', aktiv);
        if (this.kob && this.dataset.skjulKob === 'true') this.kob.classList.toggle('er-gb-udsolgt', aktiv);
        const str = v && !v.a && !this.enStr ? v.t : '';
        this.querySelector('[data-gb-knap-tekst]').textContent = fyld(this.dataset.knap, { 'størrelse': str || 'den' });
      }
      strNu() {
        const v = this.valgt();
        if (v && !v.a) return { id: v.id, t: this.enStr ? '' : v.t };
        if (this.vaelg && this.vaelg.value) return { id: this.vaelg.value, t: this.vaelg.selectedOptions[0].textContent };
        return v ? { id: v.id, t: '' } : null;
      }
      tekster() {
        const d = this.dataset;
        const s = this.strNu();
        const v = this.valgt();
        const visVaelg = !!this.vaelg && !(v && !v.a);
        const vf = this.querySelector('[data-gb-vaelg-felt]');
        if (vf) vf.hidden = !visVaelg;
        const tag = this.querySelector('[data-gb-str]');
        tag.hidden = !(s && s.t) || visVaelg;
        if (s && s.t) tag.textContent = 'Str. ' + s.t;
        const ord = { 'størrelse': s && s.t ? s.t : 'varen', vare: d.vare };
        this.querySelector('[data-gb-intro]').textContent = fyld(d.intro, ord);
        this.querySelector('[data-gb-fin]').textContent = fyld(d.fin, ord);
      }
      aaben(tak, gem) {
        this.tekster();
        this.trin(tak ? 'tak' : 'form');
        if (tak) {
          const d = this.dataset;
          const titel = this.querySelector('[data-gb-tak-titel]');
          const tekst = this.querySelector('[data-gb-tak-tekst]');
          if (gem) {
            const ord = { navn: gem.navn, email: gem.email, vare: d.vare, 'størrelse': gem.t || 'varen' };
            titel.textContent = fyld(d.takTitel, ord);
            tekst.textContent = fyld(d.takTekst, ord);
          } else {
            titel.textContent = 'Tak';
            tekst.textContent = 'Vi skriver til dig, så snart ' + d.vare + ' er tilbage på lager.';
          }
        }
        this.fejl('');
        if (this.panel.open) return;
        this.panel.showModal();
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => requestAnimationFrame(() => this.panel.classList.add('er-inde')));
        const navn = this.querySelector('[data-gb-navn]');
        if (!tak && window.matchMedia('(hover: hover)').matches) navn.focus({ preventScroll: true });
      }
      luk() {
        if (!this.panel.open) return;
        this.panel.classList.remove('er-inde');
        const ud = () => { this.panel.close(); document.documentElement.style.overflow = ''; this.knap.focus({ preventScroll: true }); };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return ud();
        let sket = false;
        const en = () => { if (sket) return; sket = true; ud(); };
        this.panel.addEventListener('transitionend', en, { once: true });
        setTimeout(en, 500);
      }
      trin(navn) {
        this.querySelectorAll('[data-gb-trin]').forEach((el) => { el.hidden = el.dataset.gbTrin !== navn; });
      }
      fejl(tekst, felt) {
        const p = this.querySelector('[data-gb-fejl]');
        p.textContent = tekst;
        p.hidden = !tekst;
        this.querySelectorAll('[data-gb-navn], [data-gb-email]').forEach((i) => i.removeAttribute('aria-invalid'));
        if (felt) { felt.setAttribute('aria-invalid', 'true'); felt.focus(); }
      }
      send() {
        if (this.sender) return;
        const navnI = this.querySelector('[data-gb-navn]');
        const emailI = this.querySelector('[data-gb-email]');
        const navn = navnI.value.trim();
        const email = emailI.value.trim();
        if (!navn) return this.fejl('Skriv dit fornavn.', navnI);
        if (!emailOk(email)) return this.fejl('Skriv en gyldig e-mail.', emailI);
        const s = this.strNu();
        if (!s) return this.fejl('Vælg en størrelse.');
        this.fejl('');
        const d = this.dataset;
        /* Tagget skal matche Flows søgning: "Giv besked: [varens titel] / [variantens titel]", også "Default Title" ved én størrelse */
        const vTitel = (this.data[s.id] && this.data[s.id].t) || s.t;
        const tagVare = (d.tagVare + (vTitel ? ' / ' + vTitel : '')).replace(/,/g, ' ').slice(0, 230);
        this.querySelector('[data-gb-tags]').value = 'Giv besked, Giv besked: ' + tagVare;
        const knap = this.querySelector('[data-gb-send]');
        this.sender = true;
        knap.setAttribute('aria-busy', 'true');
        knap.textContent = 'Sender …';
        const gem = { navn: navn, email: email, t: s.t, tid: Date.now(), sti: location.pathname };
        try { sessionStorage.setItem('spd-gb', JSON.stringify(gem)); } catch (e) {}
        /* Kunden oprettes med Shopifys egen kundeformular. Den sendes på normal vis, så Shopifys robot-tjek kan klare sig selv,
           og kommer tilbage til varen med tak */
        const u = new URL(location.href);
        u.searchParams.set('variant', s.id);
        u.searchParams.set('giv_besked', 'tak');
        this.querySelector('[data-gb-retur]').value = u.pathname + u.search;
        this.videre = true;
        try {
          this.form.submit();
        } catch (e) {
          this.videre = false;
          this.sender = false;
          knap.removeAttribute('aria-busy');
          knap.textContent = d.sendTekst || 'Giv mig besked';
          this.fejl(d.fejl);
        }
      }
    }
    customElements.define('supermen-giv-besked', SupermenGivBesked);
  })();
  } catch(e) { console.error(e); }
})();

})();
